import React, { Fragment } from 'react';
import { StyledCard, StyledCardTitle, CustomCheckbox, CustomSelect, SelectInputProps, StyledBlueCard, CustomRadio, CustomButton, CustomInputLabel, InputProps, CustomTextField, CustomSelectRounded, StyledDataGrid, DataGridProps, FlexDiv, CustomSearch, StyledTableContainer, CustomDialogContent, CustomDialogTitle } from 'custom/components';
import { Accordion, AccordionDetails, AccordionSummary, Badge, Checkbox, FormLabel, Grid, MenuItem, Radio, RadioGroup, Stack, Tooltip, Typography, Box, Card, CardHeader, Divider, CardContent, Popper, IconButton, InputAdornment, FormControl, Table, TableBody, TableCell, TableHead, TableRow, Dialog, TableFooter } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import flightInfoStyles from './fltloadinfo.module.css';
import { BinoIcon, ExcelIcon, EditIcon, DeleteIcon, PDFIcon, DollarRateIcon, CloseIconBtn, DateFormat, DateTimeFormat } from 'custom/constants';
import { ArrowDropDown, Flight, LocalShipping, Search, Warning } from '@mui/icons-material';
import theme from 'custom/theme';
import ContractData from './ContractData';
import Discrepancy from './Discrepancy';
import StatisticsSummary from './StatisticsSummary';
// import BillingFilterContainer from '../../../billingFilters/BillingFilterContainer';
import Invoice from './invoice/Invoice';
import cookies from 'utils/cookies';
import FlightReportModal from './FlightReportModal';
import FlightLoadInfoModal from './FlightLoadInfoModal';
import EncryptionContainer from '../../../common/EncryptionContainer';
import ProgressModal from 'components/pages/common/ProgressModal';
import Status from 'components/pages/common/Status';
import moment from 'moment';
import { grey } from '@mui/material/colors';

const timezone = cookies.get('timezone') || null;

const FLIGHTINFO = [
  {
    label: 'Contract Data',
    value: 'contract_data'
  },
  {
    label: 'Statistics Summary',
    value: 'statistics_summary',
  },
  {
    label: 'Statistics',
    value: 'statistics',
  },
  {
    label: 'Discrepancies',
    value: 'discrepancy'
  }
];

const exclude_nonbillable = (data, loadInfo) =>{
  if (loadInfo === 'statistics') {
    return data.filter(item => item.is_nonbillable === true);
  } else {
    return data.filter(item => item.is_nonbillable === false);
  }
  // return data;
};

const isAdhoc = <Tooltip title='Adhoc Flight' placement='top'>
  <code className={flightInfoStyles.adhocFlight}> i </code>
</Tooltip>;

// const status = (status) => {
//   let statusIndicator = '';
//   // let statusColor = 'var(--redText)';
//   switch(status) {
//     case 'Pending':
//       statusIndicator = 'P';
//       // return <span className={flightInfoStyles.flightStatus}>{statusIndicator}</span>;
//       break;
//     case 'Finalized':
//       statusIndicator = 'F';
//       break;
//       // return <span className={flightInfoStyles.flightStatus}>{statusIndicator}</span>;
//     case 'Approved' :
//       // statusIndicator = 'var(--secondarygreen)';
//       return ;
//     default: break;
//   }
//   return <span className={flightInfoStyles.flightStatus}>{statusIndicator}</span>;
// };

const getInvoice_No = (invoice_info, searchFields) => {
  let month = null;
  if (searchFields.period === 'first') {
    month = '-01';
  } else if (searchFields.period === 'second') {
    month = '-02';
  }
  let invoice_no = `${invoice_info?.file_name}`;
  if (month) {
    invoice_no = `${invoice_info?.file_name}${month}`;
  }
  return invoice_no;
};

const oldRegenerateButtonAccess = [
  'jessio@orgadynamics.com',
  'narayan@orgadynamics.com',
  'craig@orgadynamics.com',
  'noel@orgadynamics.com',
  'kevin@tryfd.com',
  'diksha@orgadynamics.com',
  'aaron@orgadynamics.com',
  'raviraj@orgadynamics.com'
];

const highlightTransitRowCheck = (row, accord_type, billingFields) =>{
  console.log('highlightTransitRowCheck _________ row, accord_type, billingFields', row, accord_type, billingFields);
  if (accord_type === 'inbound_flight') {
    return true;
  } else if (accord_type === 'outbound_flight') {
    if(billingFields.transit === 'flight' || billingFields.transit === 'truck') {
      // return false;
      if (row.inboundInfo){
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  } else {
    return true;
  }
};
const checkEqInvolved = (transit_awbs, accord_type, billingFields, contractLabel) => {
  let transitQty = 0;
  //filter transit_awbs
  transit_awbs = (transit_awbs || []).filter(
    // Filter by contractLabel
    (awb) => awb.label === contractLabel
  );
  transitQty = transit_awbs.reduce((total, awb) => {
    let qty = 0;
    if (accord_type === 'inbound_flight') {
      qty = (parseFloat(awb?.qtyValue) || 0);
    } else if (accord_type === 'outbound_flight') {
      if(billingFields.transit === 'flight' || billingFields.transit === 'truck') {
        qty = awb?.inboundInfo ? (parseFloat(awb?.qtyValue) || 0) : 0;
      } else {
        qty = (parseFloat(awb?.qtyValue) || 0);
      }
    }
    // round to 2 decimal places
    return Math.round((total + qty) * 100) / 100;
  }, 0);
  return transitQty > 0;
};

const FlightLoadInfo = (props) => {

  console.log(props, 'props in flight load info');

  let transitQty = 0;
  const transit_awbs = (props.transit_awbs || []).filter(
    // Filter by contractLabel
    (awb) => awb.label === props.contractLabel
  );

  const highlightedTransitAwbs = transit_awbs.filter((row) =>
    highlightTransitRowCheck(row, props.accord_type, props.billingFields)
  );

  const regularTransitAwbs = transit_awbs.filter((row) =>
    !highlightTransitRowCheck(row, props.accord_type, props.billingFields)
  );

  transitQty = transit_awbs?.reduce((total, awb) => {
    const accord_type = props.accord_type || '';
    let qty = 0;
    if (accord_type === 'inbound_flight') {
      qty = (parseFloat(awb?.qtyValue) || 0);
    } else if (accord_type === 'outbound_flight') {
      if(props.billingFields.transit === 'flight' || props.billingFields.transit === 'truck') {
        qty = awb?.inboundInfo ? (parseFloat(awb?.qtyValue) || 0) : 0;
      } else {
        qty = (parseFloat(awb?.qtyValue) || 0);
      }
    }
    // round to 2 decimal places
    return Math.round((total + qty) * 100) / 100;
  }, 0);

  const columns = [
    {
      field: 'label',
      headerName: 'Title',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'operation',
      headerName: 'Operation',
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        const { row } = params;
        return (
          <div>
            {row.operation === 'ADD' ? 'Add' : 'Subtract'}
          </div>
        );
      }
    },
    {
      field: 'amount',
      headerName: 'Amount',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'cycle',
      headerName: 'Cycle',
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        const { row } = params;
        return (
          <div>
            {row.cycle === 'C1' ? 'Cycle1' : row.cycle === 'C2' ? 'Cycle2' : 'Cycle1 & Cycle2'}
          </div>
        );
      }
    },
    {
      field: 'action',
      headerName: 'Action',
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        const { row, id } = params;
        return (
          <Stack direction='row' spacing={1} justifyContent='center' className={styles.actionIcons}>
            <EditIcon onClick={() => props.editOneOff(id-1, row)} />
            <DeleteIcon onClick={() => props.deleteOneOff(id-1, row)} />
          </Stack>
        );
      }
    },
  ];

  const CONT_ITEM_CODES = {
    CH: 'Cargo Handling',
    DR: 'Drayage',
    FO: 'Flight Ops',
  };

  const infoRef = React.useRef(null);
  // const statRef = React.useRef(null);
  const desRef = React.useRef(null);
  // let filename = '';
  // const getFilename = (invoice_info, combinationAirline, airlineCode, cont_item/*, period, billingFields*/) => {
  //   if(props.invoice_info?.combinationId) {
  //     let combination = combinationAirline.find(item => item.combinationId === invoice_info.combinationId);
  //     filename = `${combination?.code || airlineCode}-${cont_item}-${cookies.get('station_code')}-Invoice`;
  //   } else {
  //     filename = `${props.airlineCode}-${props.cont_item}-${cookies.get('station_code')}-Invoice`;
  //   }
  //   console.log('Generated filename:', filename);
  //   return filename;
  // };
  const getFilename = (invoice_info, combinationAirline, airlineCode) => {
    const invoiceCode = invoice_info?.invoice_code;

    if (!invoiceCode) {
      return '';
    }

    let airline;
    let station;
    let contItem;

    if (invoiceCode.startsWith('INV-')) {
      // INV-AC-CH-STN-JAN2024
      const parts = invoiceCode.split('-');

      airline = parts[1];
      contItem = parts[2];
      station = parts[3];
    } else {
      // ACSTNCHJAN2024
      // ACSTN01JAN2024

      const combination = combinationAirline.find(
        item => item.combinationId === invoice_info?.combinationId
      );

      airline = combination?.code || airlineCode;
      station = cookies.get('station_code');

      // Remove airline + station from beginning
      const prefix = `${airline}${station}`;
      const remaining = invoiceCode.substring(prefix.length);

      // Find known cont_item code
      console.log('CONT_ITEM_CODES', CONT_ITEM_CODES );
      console.log('remaining', remaining);
      const contItemCode = Object.keys(CONT_ITEM_CODES).find(code =>
        remaining.startsWith(code)
      );

      if (contItemCode) {
        contItem = contItemCode;
      } else {
        // e.g. 01JAN2024 means no cont_item
        contItem = '';
      }
    }

    const filename = contItem
      ? `${airline}-${contItem}-${station}-Invoice`
      : `${airline}-${station}-Invoice`;

    console.log('Generated filename:', filename);

    return filename;
  };

  const invoiceDownload =
    (cookies.get('role') === 'Accounting' || cookies.get('role') === 'System Admin' || cookies.get('role') === 'Manager') && props.loadInfo === 'contract_data' ?
      <Stack direction='row' justifyContent='space-around' alignItems='center' className={flightInfoStyles.downloadInvoice}>
        <Invoice
          invoice_no={getInvoice_No(props.invoice_info, props.searchFields)}
          flightdata={[]}
          daylogdata={[]}
          monthlogdata={[]}
          // invoiceData={props.alcontractsData}
          invoiceData={ exclude_nonbillable(props.alcontractsData, props.loadInfo) }
          dayContractData={exclude_nonbillable(props.dayContractData, props.loadInfo)}
          monthContractData={exclude_nonbillable(props.monthContractData, props.loadInfo)}
          invoice_info={props.invoice_info}
          airlineCode={props.airlineCode}
          title='Invoice (Gross)'
          cont_item={props.cont_item}
          searchFields={props.searchFields}
          // filename={`${props.airlineCode}-${props.cont_item}-${cookies.get('station_code')}-Invoice`}
          //handle filename for combination and individual airline
          filename = { getFilename(props.invoice_info, props.combinationAirline, props.airlineCode, props.cont_item /*, props.searchFields.period, props.billingFields*/) }
          billingFields={props.billingFields}
          oneOff={props.oneOff.filter(item => item.cycle?.includes('C1') && props.searchFields.period === 'first' || item.cycle?.includes('C2') && props.searchFields.period === 'second' || props.searchFields.period === 'month')}
          progress={props.progress} 
          handleEmailPassword={props.handleEmailPassword}
        />
        {/* <Invoice
          invoice_no={getInvoice_No(props.invoice_info, props.searchFields)}
          flightdata={[]}
          daylogdata={[]}
          monthlogdata={[]}
          // invoiceData={props.alcontractsData}
          invoiceData={ exclude_nonbillable(props.alcontractsData, props.loadInfo) }
          dayContractData={exclude_nonbillable(props.dayContractData, props.loadInfo)}
          monthContractData={exclude_nonbillable(props.monthContractData, props.loadInfo)}
          invoice_info={props.invoice_info}
          airlineCode={props.airlineCode}
          title='Invoice (Gross) - Old'
          cont_item={props.cont_item}
          searchFields={props.searchFields}
          filename={`${props.airlineCode}-${props.cont_item}-${cookies.get('station_code')}-Invoice`}
          billingFields={props.billingFields}
          oneOff={props.oneOff.filter(item => item.cycle?.includes('C1') && props.searchFields.period === 'first' || item.cycle?.includes('C2') && props.searchFields.period === 'second' || props.searchFields.period === 'month')}
          progress={props.progress} 
          handleEmailPassword={props.handleEmailPassword}
          useOldLogic={true}
        /> */}
        <Invoice
          invoice_no={getInvoice_No(props.invoice_info, props.searchFields)}
          flightdata={props.flightdata.filter(flight => flight.pending !== true)}
          daylogdata={props.daylogdata.filter(item => item.pending !== true)}
          monthlogdata={props.monthlogdata}
          // invoiceData={props.alcontractsData}
          invoiceData={ exclude_nonbillable(props.alcontractsData, props.loadInfo) }
          dayContractData={exclude_nonbillable(props.dayContractData, props.loadInfo)}
          monthContractData={exclude_nonbillable(props.monthContractData, props.loadInfo)}
          invoice_info={props.invoice_info}
          airlineCode={props.airlineCode}
          title='Invoice (Itemized)'
          cont_item={props.cont_item}
          searchFields={props.searchFields}
          // filename={`${props.airlineCode}-${props.cont_item}-${cookies.get('station_code')}-Invoice`}
          //handle filename for combination and individual airline
          filename = { getFilename(props.invoice_info, props.combinationAirline, props.airlineCode, props.cont_item /*, props.searchFields.period, props.billingFields*/) }
          billingFields={props.billingFields}
          oneOff={props.oneOff.filter(item => item.cycle?.includes('C1') && props.searchFields.period === 'first' || item.cycle?.includes('C2') && props.searchFields.period === 'second' || props.searchFields.period === 'month')}
          progress={props.progress}
          handleEmailPassword={props.handleEmailPassword}
        />
        {/* <Invoice
          invoice_no={getInvoice_No(props.invoice_info, props.searchFields)}
          flightdata={props.flightdata.filter(flight => flight.pending !== true)}
          daylogdata={props.daylogdata.filter(item => item.pending !== true)}
          monthlogdata={props.monthlogdata}
          // invoiceData={props.alcontractsData}
          invoiceData={ exclude_nonbillable(props.alcontractsData, props.loadInfo) }
          dayContractData={exclude_nonbillable(props.dayContractData, props.loadInfo)}
          monthContractData={exclude_nonbillable(props.monthContractData, props.loadInfo)}
          invoice_info={props.invoice_info}
          airlineCode={props.airlineCode}
          title='Invoice (Itemized) - Old'
          cont_item={props.cont_item}
          searchFields={props.searchFields}
          filename={`${props.airlineCode}-${props.cont_item}-${cookies.get('station_code')}-Invoice`}
          billingFields={props.billingFields}
          oneOff={props.oneOff.filter(item => item.cycle?.includes('C1') && props.searchFields.period === 'first' || item.cycle?.includes('C2') && props.searchFields.period === 'second' || props.searchFields.period === 'month')}
          progress={props.progress}
          handleEmailPassword={props.handleEmailPassword}
          useOldLogic={true}
        /> */}
      </Stack> : null;

  // const handleExport = async (e) => {
  //   console.log('props.loadInfo', e);
  //   if (props.loadInfo == 'contract_data') {
  //     let csv = await infoRef.current.getDataAsCsv();
  //     CsvToExcel(csv, 'Contract Data');
  //   }
  //   if (props.loadInfo == 'statistics') {
  //     // if (props.accord_type) {
  //     //   csv = await statRef.current.getDataAsCsv();
  //     // } else {
  //     let sData = [];
  //     props.billingData.map((column) => {
  //       let data = {
  //         'Lable': column?.ex_label,
  //         'Flight': column?.flight_count,
  //       };
  //       props.billingColumns.map((c) => {
  //         data[c.headerName] = c.headerName != 'AWBS' ? column?.[c.field] : column?.contractData?.length;
  //       });
  //       sData.push(data);
  //       data = {};
  //       data = {
  //         'Lable': column?.inbound?.ex_label,
  //         'Flight': column?.inbound?.flight_count,
  //       };
  //       props.billingColumns.map((c) => {
  //         data[c.headerName] = c.headerName != 'AWBS' ? column?.inbound?.[c.field] : column?.inbound?.contractData?.length;
  //       });
  //       sData.push(data);
  //       if (column?.inbound?.flights?.length > 0) {
  //         column?.inbound?.flights.map((flight) => {
  //           data = {};
  //           data = {
  //             'Lable': flight.label,
  //             'Flight': flight.flight_count,
  //           };
  //           props.billingColumns.map((c) => {
  //             data[c.headerName] = c.headerName != 'AWBS' ? flight[c.field] : flight.contractData?.length;
  //           });
  //           sData.push(data);
  //         });
  //       }
  //       data = {};
  //       data = {
  //         'Lable': column?.outbound?.ex_label,
  //         'Flight': column?.outbound?.flight_count,
  //       };
  //       props.billingColumns.map((c) => {
  //         data[c.headerName] = c.headerName != 'AWBS' ? column?.outbound?.[c.field] : column?.outbound?.contractData?.length;
  //       });
  //       sData.push(data);
  //       if (column?.outbound?.flights?.length > 0) {
  //         column?.outbound?.flights.map((flight) => {
  //           data = {};
  //           data = {
  //             'Lable': flight.label,
  //             'Flight': flight.flight_count,
  //           };
  //           props.billingColumns.map((c) => {
  //             data[c.headerName] = c.headerName != 'AWBS' ? flight[c.field] : flight.contractData?.length;
  //           });
  //           sData.push(data);
  //         });
  //       }
  //     });
  //     JsonToExcel(sData, 'Statistics');
  //     // }
  //   }
  //   if (props.loadInfo == 'discrepancy') {
  //     if (props.accord_type && props.accord_type != 'airline') {
  //       let csv = await desRef.current.getDataAsCsv();
  //       CsvToExcel(csv, 'Discrepancy');
  //     } else {
  //       let sData = [];
  //       discrepancyType.map((type) => {
  //         sData.push({
  //           'Type': type,
  //           'Total': props.billingData[0][type],
  //           'Inbound': props.billingData[0]?.inbound[type],
  //           'Outbound': props.billingData[0]?.outbound[type]
  //         });
  //       });
  //       JsonToExcel(sData, 'Discrepancy');
  //     }
  //   }
  // };

  return <>
    {/* <BillingFilterContainer
      onFilterMain={props.onFilterMain}
      flightFields={props.flightFields}
      searchFields={props.searchFields}
      airlines={props.airlines}
      handleContractType={props.handleContractType}
      contract_Type={props.contract_Type}
      loadInfo={props.loadInfo}
    /> */}


    {/* <div>
      <CustomCheckbox
        control={
          <Checkbox
            inputProps={{ 'aria-label': 'flight-info' }}
            checked={props.showOneOff}
            onChange={props.showHideOneOff}
            name='view_oneoff'
          />
        }
        label='Show One Off'
        className={`${styles.mr1} ${styles.fJustifyEnd}`}
      />
    </div> */}
    {props.showOneOff &&
    <StyledCard className={`${styles.mb4}`}>
      <StyledCardTitle gutterBottom>Flight Info</StyledCardTitle>
      <Grid container spacing={2} alignItems='center'>
        <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
          <CustomInputLabel htmlFor='routing' aria-label='Enter Label'>Label</CustomInputLabel>
          <CustomTextField
            {...InputProps}
            id='label'
            name='label'
            fullWidth
            autoFocus
            type='text'
            value={props?.oneOffEdit?.label}
            onChange={props.handleOneOffChange}
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
          <CustomInputLabel htmlFor='routing' aria-label='Select an Operat'>Operation</CustomInputLabel>
          <CustomSelectRounded
            id='operation'
            name='operation'
            label={false}
            value={props.oneOffEdit?.operation || 'placeholder'}
            onChange={props.handleOneOffChange}
            className={`${styles.minWidth200} ${styles.fOne}`}
          >
            <MenuItem value='placeholder' disabled>Select an operation</MenuItem>
            <MenuItem key={'ADD'} value={'ADD'}>Add</MenuItem>
            <MenuItem key={'SUB'} value={'SUB'}>Subtract</MenuItem>

          </CustomSelectRounded>
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
          <CustomInputLabel htmlFor='routing' aria-label='Enter Amount'>Amount</CustomInputLabel>
          <CustomTextField
            {...InputProps}
            id='amount'
            name='amount'
            fullWidth
            autoFocus
            type='text'
            value={props?.oneOffEdit?.amount}
            onChange={props.handleOneOffChange}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={2} xl={2}>
          <CustomInputLabel htmlFor='routing' aria-label='Select Cycle'>Cycle</CustomInputLabel>
          <CustomSelectRounded
            id='cycle'
            name='cycle'
            label={false}
            value={props.oneOffEdit?.cycle || 'placeholder'}
            onChange={props.handleOneOffChange}
            className={`${styles.minWidth200} ${styles.fOne}`}
          >
            <MenuItem value='placeholder' disabled>Select a cycle</MenuItem>
            <MenuItem key={'C1'} value={'C1'}>Cycle1</MenuItem>
            <MenuItem key={'C2'} value={'C2'}>Cycle2</MenuItem>
            <MenuItem key={'C1,C2'} value={'C1,C2'}>Cycle1 & Cycle2</MenuItem>
          </CustomSelectRounded>
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={1} xl={1}>
          <CustomButton variant='contained' className={`${styles.minWidth280}`} name='reopen' onClick={() => props.updateOneOff()} > Save </CustomButton>
        </Grid>
        <Grid item xs={12} sm={6} md={3} lg={1} xl={1}>
          {
            props.oneOffEdit?.index !== null &&
            <CustomButton variant='contained' className={`${styles.minWidth280}`} name='reopen' onClick={() => props.clearOneOff()} > Cancel </CustomButton>
          }
        </Grid>
      </Grid>
      <div className={styles.tableWrapper}>
        <Box className={`${styles.tableOuter}`}>
          <StyledDataGrid
            {...DataGridProps}
            rows={props.oneOff || []}
            columns={columns}
            param={props.oneOff?.length}
          />
        </Box>
      </div>
      
    </StyledCard>}

    <StyledCard>
      <Stack direction='row' justifyContent='space-between' alignItems='center' className={`${styles.mb2} ${styles.pb2}`} borderBottom={'1px solid #dfdfdf'} minHeight={'40px'}>

        <Grid container spacing={{
          xs: 2,
          lg: 0
        }}>
          <Grid item xs={'auto'} className={flightInfoStyles.flightInfo}>
            <FlexDiv><StyledCardTitle>Flight Load Info</StyledCardTitle></FlexDiv>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            <RadioGroup
              aria-labelledby='contract-type-radio-buttons-group'
              name='contract-type-radio-buttons-group'
              value={props.loadInfo}
              row
              onChange={props.handleToggle}
              className={styles.radioToggleGroup}
            >
              { props.statisticsSummary === true ? FLIGHTINFO.map((value, index) => {
                return (
                  <Fragment key={index}>
                    <CustomRadio
                      value={value.value}
                      control={<Radio className={styles.radioToggleBtn} />}
                      label={value.label}
                      className={`${styles.radioToggle} ${props.loadInfo === value.value ? styles.radioToggleBtnChecked : ''
                      }`}
                      classes={{ label: styles.radioToggleLabel }}
                    />
                    {value.label == 'Discrepancies' && (<Badge color='error' badgeContent={props.discrepancyCount} />)}
                  </Fragment>
                );
              }) : FLIGHTINFO.filter((value) => value.value !== 'statistics_summary').map((value, index) => {
                return (
                  <Fragment key={index}>
                    <CustomRadio
                      value={value.value}
                      control={<Radio className={styles.radioToggleBtn} />}
                      label={value.label}
                      className={`${styles.radioToggle} ${props.loadInfo === value.value ? styles.radioToggleBtnChecked : ''
                      }`}
                      classes={{ label: styles.radioToggleLabel }}
                    />
                    {value.label == 'Discrepancies' && (<Badge color='error' badgeContent={props.discrepancyCount} />)}
                  </Fragment>
                );
              })}
            </RadioGroup>
          </Grid>
          
          <Grid item xs>
            <Stack direction={'row'} spacing={2} justifyContent={'flex-end'} alignItems={'center'}>
              {(props.loadInfo === 'contract_data' || props.loadInfo === 'statistics') ? (
                <>
                  {cookies.get('role') === 'System Admin' &&
                  <>
                    { (cookies.get('email') && oldRegenerateButtonAccess.includes(cookies.get('email').toLowerCase())) &&
                      <CustomButton variant='contained' color='primary' size='small' sx={{ py: props.invoice_info?.lastUpdatedDt ? '2px' : '6px' }}
                        className={`${styles.tableBtn} ${flightInfoStyles.regBtn}`} onClick={() => props.triggerNewBilling('true')} disabled={!props.billingExists || cookies.get('role') !== 'System Admin'} >
                        <Stack direction='column'>
                          <Typography component={'div'} variant='body2' fontSize={'0.85rem'}>Regenerate Old</Typography>
                          {props.invoice_info?.lastUpdatedDt &&
                        <Typography component={'span'} variant='caption' fontSize={'9px'} color='#c8c8c8' lineHeight='normal'>
                          Last updated { props.invoice_info?.lastUpdatedDt ? moment.utc(props.invoice_info?.lastUpdatedDt).tz(timezone).format(`${DateTimeFormat} A`).toUpperCase() : '' }
                        </Typography>}
                        </Stack>
                      </CustomButton>
                    }
                    <CustomButton variant='contained' color='primary' size='small' sx={{ py: props.invoice_info?.lastUpdatedDt ? '2px' : '6px' }}
                      className={`${styles.tableBtn} ${flightInfoStyles.regBtn}`} onClick={() => props.triggerNewNewBilling('true')} disabled={!props.billingExists || cookies.get('role') !== 'System Admin'} >
                      <Stack direction='column'>
                        <Typography component={'div'} variant='body2' fontSize={'0.85rem'}>Regenerate</Typography>
                        {props.invoice_info?.lastUpdatedDt &&
                        <Typography component={'span'} variant='caption' fontSize={'9px'} color='#c8c8c8' lineHeight='normal'>
                          Last updated { props.invoice_info?.lastUpdatedDt ? moment.utc(props.invoice_info?.lastUpdatedDt).tz(timezone).format(`${DateTimeFormat} A`).toUpperCase() : '' }
                        </Typography>}
                      </Stack>
                    </CustomButton>
                  </>
                  }
                  {
                    //Show button to authenticate, if authenticated show download button
                    cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && !cookies.get('managecdt') ?
                      <Box sx={{
                        [`& .${styles.squareIcon}`]: {
                          height: '32px',
                          width: '28px',
                          marginTop: '-1px',
                          marginRight: '0px !important', 
                        },
                      }}>
                        <DollarRateIcon title='Secure Billing Access' 
                          onClick={() => props.handleOpen('encryption', null, null, null)}  /> 
                      </Box>
                      :
                      (cookies.get('role') === 'System Admin' || cookies.get('role') === 'Accounting' )
                        && cookies.get('ismanagec') && cookies.get('ismanagec') == 'true' && cookies.get('managecdt') ?
                        <PDFIcon title='Download Invoice' onClick={(event) => {
                          if (!props.genInvProgress && props.invoice_info) {
                            props.handleOpen('downloadProgress', event);
                          }
                        }} className={`${styles.tableIcon}`} disabled={props.genInvProgress || !props.invoice_info } />
                        : ''}
                  <ExcelIcon title='Download File' onClick={() => props.onModalOpen('flt_load_info')} className={styles.tableIcon} />
                </>
              ) : 
                <ExcelIcon title='Download File' onClick={() => props.onModalOpen('flt_load_info')} className={styles.tableIcon} />
              }
            </Stack>
          </Grid>
          
        </Grid>
      </Stack>

      <Grid container spacing={3}>
        <Grid item className={flightInfoStyles.flightInfo} order={{ xs: 1 }}>
          <StyledBlueCard className={flightInfoStyles.fltPaper}>
            <Stack direction='row' spacing={2} alignItems='center' justifyContent={'space-between'} mb={2}>
              <Typography variant='caption' component='p' whiteSpace='nowrap'
                lineHeight='normal' color={theme.palette.common.white} fontSize={'14px'} fontWeight={700} marginBottom={'14px'}>
              Drill Down
              </Typography>
              <CustomSearch
                id='search'
                variant='outlined'
                size='small'
                type='search'
                placeholder='Search Flight'
                name='search'
                className={`${styles.brInput} ${flightInfoStyles.searchBox}`}
                value={props?.filterData?.search}
                onChange={props.handleFilterChange}
                InputProps={{
                  classes: {
                    root: flightInfoStyles.searchBoxRoot,
                    input: flightInfoStyles.searchBoxInput
                  },
                  endAdornment: <InputAdornment position='end'>
                    <IconButton
                      size='small'
                      aria-label='search'
                      edge='end'
                      onClick={props.filter}
                    >
                      <Search fontSize='1rem' />
                    </IconButton>
                  </InputAdornment>,
                }}
                onKeyDown={
                  (e) => {
                    if (e.key === 'Enter') {
                      props.filter(true);
                    }
                  }
                }
              />
            </Stack>
            {
              props.filteredBillingData && props.filteredBillingData.length > 0 && (props.filteredBillingData.map((data, i) => {
                let totalPendingFlights = 0;
                let inboundPendingFlights = 0;
                let outboundPendingFlights = 0;
                let pendingText = 'Not Finalized';

                inboundPendingFlights = data?.inbound.flights.reduce((count, flight) => flight.status === 'Not Finalized' ? count + 1 : count, 0);
                outboundPendingFlights = data?.outbound.flights.reduce((count, flight) => flight.status === 'Not Finalized' ?  count + 1 : count, 0);
                totalPendingFlights = inboundPendingFlights + outboundPendingFlights;

                return (
                  <Accordion expanded={props.expandedFlight === 'flight'} onChange={props.handleChange('flight')} disableGutters className={flightInfoStyles.accordionFlight} key={i} >
                    <AccordionSummary
                      // className={flightInfoStyles.accordionSummaryFlight}
                      className={(props.accord_type === 'airline' && props.accord_id === data.id ?
                        `${flightInfoStyles.selectedFlight} ${flightInfoStyles.accordionSummaryFlight}` :
                        flightInfoStyles.accordionSummaryFlight)}
                      classes={{
                        content: flightInfoStyles.accordionContentFlight,
                        expanded: flightInfoStyles.accordionFlightExpanded
                      }}
                      expandIcon={<ArrowDropDown />}
                      aria-controls='panel1-content'
                      id='panel1-header'
                      onClick={() => props.setContTBData(data, 'airline')}
                    >
                      {
                        data.label
                      }
                      {(props.loadInfo === 'contract_data' || props.loadInfo === 'statistics') &&
                      <Typography component={'span'} fontSize={'inherit'} color={'error'} fontWeight={'600'}>
                        ({totalPendingFlights + ' ' + pendingText})</Typography>
                      }
                    </AccordionSummary>
                    <AccordionDetails className={`${flightInfoStyles.accordionDetailsFlightMain} ${flightInfoStyles.fltDetails}`}>
                      <Accordion expanded={props.expanded === 'inbound'} onChange={props.handleChange('inbound')}
                        disableGutters className={flightInfoStyles.accordionFlight}>
                        <AccordionSummary
                          // className={flightInfoStyles.accordionSummaryFlight}
                          className={props.accord_type === 'inbound' && props.accord_id === data?.inbound?.id ?
                            `${flightInfoStyles.selectedFlight} ${flightInfoStyles.accordionSummaryFlight}` :
                            flightInfoStyles.accordionSummaryFlight}
                          classes={{
                            content: flightInfoStyles.accordionContentFlight,
                            expanded: flightInfoStyles.accordionFlightExpanded
                          }}
                          onClick={() => props.setContTBData(data.inbound, 'inbound')}
                          expandIcon={<ArrowDropDown />}
                          aria-controls='panel1-content'
                          id='panel1-header'
                        >
                          {
                            data?.inbound?.label
                          }
                          {(props.loadInfo === 'contract_data' || props.loadInfo === 'statistics') &&
                          <Typography component={'span'} fontSize={'inherit'} color={'error'} fontWeight={'600'}>
                            ({inboundPendingFlights + ' ' + pendingText})
                          </Typography>}
                        </AccordionSummary>
                        <AccordionDetails className={`${flightInfoStyles.accordionDetailsFlightMain} ${flightInfoStyles.fltDetailsInner}`}>
                          {data.inbound?.flights?.map((flight, i) => (
                            <Fragment key={i} >
                              <div
                                // className={`${flightInfoStyles.accordionDetailsFlight} ${styles.positionRelative}`} 
                                className={`${(props.accord_type === 'inbound_flight' && props.accord_id === flight.id) ? flightInfoStyles.selectedFlight : ''}
                                  ${flight?.status === 'Rejected' ? flightInfoStyles.pending : ''}
                                  ${flightInfoStyles.accordionDetailsFlight} 
                                  ${styles.positionRelative}`
                                }
                                onClick={() => props.setContTBData(flight, 'inbound_flight')} >
                                <div className={flightInfoStyles.flightLabelWrapper}>
                                  <p>{flight?.status === 'Rejected' &&
                                    <>
                                      <Warning sx={{
                                        fontSize: 18,
                                        marginBottom: '-2px',
                                        marginRight: '2px'
                                      }} color='error' />
                                    </>}
                                  {flight?.label?.toUpperCase()}</p>
                                  {flight?.status === 'Not Finalized' || flight?.status === 'Submitted' ?
                                    <Typography component={'p'} variant='caption' fontSize={'0.7rem'} color={'error'} pt={0.1}>(Not Finalized)</Typography> :
                                    flight?.status === 'Finalized' || flight?.status === 'Pending' || flight?.status === 'Approved' ?
                                      <Typography component={'p'} variant='caption' fontSize={'0.7rem'} color={'black'} pt={0.1}>(Finalized)</Typography> : 
                                      flight?.status === 'Rejected' ?
                                        <>
                                          <IconButton
                                            onMouseEnter={(e) => props.handlePopover(e, flight)}
                                            onMouseLeave={props.handlePopoverClose} 
                                            disableRipple
                                            className={`${styles.positionRelative} ${styles.p0}`}
                                          >
                                            <Typography component={'p'} variant='caption' fontSize={'0.7rem'} color={'error'} pt={0.1}>(Rejected)</Typography>
                                          </IconButton>
                                        </>
                                        : flight?.status === 'No OP' ?
                                          <Typography component={'p'} variant='caption' fontSize={'0.7rem'} color={grey[700]} pt={0.1}>(No Ops)</Typography>
                                          : ''
                                          // : <Typography component={'p'} variant='caption' fontSize={'0.7rem'} color={'black'} pt={0.1}>({flight?.status})</Typography>
                                  }
                                </div> 
                                {/* For Adhoc Flights */}
                                {!flight.flight_schedule_id ? isAdhoc : ''} 
                                <BinoIcon title='View Flight Report' className={`${styles.smActionIcons} ${flightInfoStyles.reportIcon}`}
                                  onClick={() => props.handleFlight('inbound', flight)} />
                              </div>
                            </Fragment>
                          ))}
                        </AccordionDetails>
                      </Accordion>

                      <Accordion expanded={props.expanded === 'outbound'} onChange={props.handleChange('outbound')}
                        disableGutters className={flightInfoStyles.accordionFlight}>
                        <AccordionSummary
                          onClick={() => props.setContTBData(data.outbound, 'outbound')}
                          // className={flightInfoStyles.accordionSummaryFlight}
                          className={props.accord_type === 'outbound' && props.accord_id === data?.outbound?.id ?
                            `${flightInfoStyles.selectedFlight} ${flightInfoStyles.accordionSummaryFlight}` :
                            flightInfoStyles.accordionSummaryFlight}
                          classes={{
                            content: flightInfoStyles.accordionContentFlight,
                            expanded: flightInfoStyles.accordionFlightExpanded
                          }}
                          expandIcon={<ArrowDropDown />}
                          aria-controls='panel1-content'
                          id='panel1-header'
                        >
                          {
                            data?.outbound?.label
                          }
                          {(props.loadInfo === 'contract_data' || props.loadInfo === 'statistics') &&
                          <Typography component={'span'} fontSize={'inherit'} color={'error'} fontWeight={'600'}>
                            ({outboundPendingFlights + ' ' + pendingText})</Typography>
                          }
                        </AccordionSummary>
                        <AccordionDetails className={`${flightInfoStyles.accordionDetailsFlightMain} ${flightInfoStyles.fltDetailsInner}`}>
                          {data.outbound?.flights?.map((flight, i) => (
                            <Fragment key={i} >
                              <div
                                // className={`${flightInfoStyles.accordionDetailsFlight} ${styles.positionRelative}`}
                                className={`${(props.accord_type === 'outbound_flight' && props.accord_id === flight.id) ? 
                                  flightInfoStyles.selectedFlight : ''} 
                                  ${flight.pending ? flightInfoStyles.pending : ''} 
                                  ${flightInfoStyles.accordionDetailsFlight} ${styles.positionRelative}`}
                                onClick={() => props.setContTBData(flight, 'outbound_flight')} >
                                <div className={flightInfoStyles.flightLabelWrapper}>
                                  <p>{flight?.status === 'Rejected' &&
                                    <>
                                      <Warning sx={{
                                        fontSize: 18,
                                        marginBottom: '-2px',
                                        marginRight: '2px'
                                      }} color='error' />
                                    </>}
                                  {flight?.label?.toUpperCase()}</p>
                                  {flight?.status === 'Not Finalized' || flight?.status === 'Finalized' ?
                                    <Typography component={'p'} variant='caption' fontSize={'0.7rem'} color={'black'} pt={0.1}>({flight?.status})</Typography> : 
                                    flight?.status === 'Rejected' ?
                                      <>
                                        <IconButton
                                          onMouseEnter={(e) => props.handlePopover(e, flight)}
                                          onMouseLeave={props.handlePopoverClose} 
                                          disableRipple
                                          className={`${styles.positionRelative} ${styles.p0}`}> 
                                          <Typography component={'p'} variant='caption' fontSize={'0.7rem'} color={'error'} pt={0.1} fontWeight={600}>&nbsp;(Rejected)</Typography>
                                        </IconButton>
                                      </>
                                      : flight?.status === 'No OP' ?
                                        <Typography component={'p'} variant='caption' fontSize={'0.7rem'} color={grey[700]} pt={0.1}>(No Ops)</Typography>
                                        : ''
                                        // : <Typography component={'p'} variant='caption' fontSize={'0.7rem'} color={'black'} pt={0.1}>({flight?.status})</Typography>
                                  }
                                </div> 
                                {/* For Adhoc Flights */}
                                {!flight.flight_schedule_id ? isAdhoc : ''} 
                                <BinoIcon title='View Flight Report' className={`${styles.smActionIcons} ${flightInfoStyles.reportIcon}`}
                                  onClick={() => props.handleFlight('outbound', flight)} />
                              </div>
                            </Fragment>
                          ))}
                        </AccordionDetails>
                      </Accordion>

                    </AccordionDetails>
                  </Accordion>
                );
              }))
            }
          </StyledBlueCard>
        </Grid>

        <Grid item xs className={`${flightInfoStyles.flightsLoadInfo} ${styles.positionRelative}`} order={{
          xs: 1,
          sm: 1,
          md: 1,
          lg: 1,
        }}>
          <Stack direction='row' spacing={7} mb={2} alignItems={'center'} justifyContent='flex-start' flexWrap='wrap' pt={'10px'}>
            {!props.manifestDate && <FormControl className={flightInfoStyles.scheduledActualRadio}>
              <FormLabel component='small' className={`${styles.xsW100} ${styles.mr3}`}><small>Adjust billing as per:</small> </FormLabel>
              <RadioGroup
                row
                aria-labelledby='scheduled-actual-radio-group'
                name='dateType'
                value={props.billingFields.dateType || 'scheduled'}
                onChange={props.onChange}
              >
                <CustomRadio value='scheduled' control={<Radio />} label='Sch Events' />
                <CustomRadio value='actual' control={<Radio />} label='Act Events' />
              </RadioGroup>
            </FormControl>}
            {props.loadInfo != 'discrepancy' && (
              <> 
                <CustomCheckbox
                  control={
                    <Checkbox inputProps={{ 'aria-label': 'Friday', }} checked={props.billingFields.exclude_disc} onChange={props.changeCheck} name='exclude_disc' />
                  } label='Exclude Discrepancies' />
                <FormControl sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center' 
                }}>
                  <Typography variant='caption' component='span' lineHeight='normal' fontSize={'0.875rem'} color='primary'>
                              Equalize transit at
                  </Typography>&nbsp; &nbsp;
                  <CustomSelect
                    {...SelectInputProps}
                    id='airline'
                    labelId='airline-label'
                    fullWidth
                    onChange={props.onChange}
                    name='transit'
                    // className={billingStyles.tableTextField}
                    style={{ width: '100px' }}
                    value={!props.billingFields.transit ? 'none' : props.billingFields.transit}
                  >
                    <MenuItem value='inbound'>Inbound</MenuItem>
                    <MenuItem value='outbound'>Outbound</MenuItem>
                    <MenuItem value='flight'>Flight</MenuItem>
                    {/* <MenuItem value='truck'>Truck</MenuItem> */}
                    <MenuItem value='none'>None</MenuItem>
                  </CustomSelect>
                </FormControl>
                {
                  props.billingFields.transit === 'truck' || props.billingFields.transit === 'flight' ?
                    <FormControl sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center' 
                    }}>
                      <Typography variant='caption' component='span' lineHeight='normal' fontSize={'0.875rem'} color='primary'>
                          Prioritization
                      </Typography>&nbsp; &nbsp;
                      <CustomSelect
                        {...SelectInputProps}
                        id='priority'
                        labelId='priority-label'
                        fullWidth
                        onChange={props.onChange}
                        name='priority'
                        // className={billingStyles.tableTextField}
                        style={{ width: '150px' }}
                        disabled={props.billingFields.transit === 'flight' ? true : false}
                        value={!props.billingFields.priority ? 'none' : props.billingFields.priority}
                      >
                        {/* <MenuItem value='inbound'>Inbound</MenuItem> */}
                        <MenuItem value='outbound'>Outbound</MenuItem>
                      </CustomSelect>
                    </FormControl> : null
                }
              </>
            )}
          </Stack>
          {(props.loadInfo === 'contract_data' || props.loadInfo === 'statistics') && (
            <ContractData
              contractData={ exclude_nonbillable(props.contractData, props.loadInfo) }
              flightdata={props.flightdata}
              daylogdata={props.daylogdata}
              monthlogdata={props.monthlogdata}
              dayContractData={props.dayContractData}
              monthContractData={props.monthContractData}
              airlineCode={props.airlineCode}
              accord_type={props.accord_type}
              apiRef={infoRef}
              billingFields={props.billingFields}
              handleTableCollapse={props.handleTableCollapse}
              collapse={props.collapse}
              transit_awbs={props.transit_awbs}
              showTransitAWBs={props.showTransitAWBs}
              checkEqInvolved={checkEqInvolved}
              expanded={props.expanded}
            />
          )}
          {props.loadInfo === 'statistics_summary' && (
            <StatisticsSummary
              billingColumns={props.billingColumns}
              contractData={props.contractData}
              summaryData={props.summaryData}
              showSummary={props.showSummary}
              billingCol={props.billingCol}
              billingData={props.billingData}
            // apiRef={statRef}
            />)}
          {props.loadInfo === 'discrepancy' && (
            <Discrepancy contractData={props.contractData}
              showSummary={props.showSummary}
              billingData={props.billingData}
              apiRef={desRef}
            />
          )}
        </Grid>

      </Grid>
    </StyledCard>

    <Popper 
      id={'id'} 
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      placement='right-start'
    >
      <Card className={flightInfoStyles.statusPopover}>
        <CardHeader
          className={flightInfoStyles.statusPopoverHeader}
          title={<>
            <Typography variant='h6' color={grey[700]} fontSize='1rem' lineHeight='normal' textTransform={'capitalize'}>
              {props.contract_Type || ''}
            </Typography>
            <Typography variant='caption' color={'error'} fontWeight={700} lineHeight='normal' marginTop={'4px'} display='block'>
              {props.popoverData?.status || ''}
            </Typography>
          </>
          }>
        </CardHeader>
        <Divider  />
        <CardContent className={styles.p3}>
          <p className={flightInfoStyles.statusDesc}> 
            <Typography variant='caption' component='span' color={'black'} lineHeight='normal' textTransform={'capitalize'}>
              {props.popoverData?.last_log?.user?.role}
            </Typography>
            <span className={flightInfoStyles.statusIndicator}>{props.popoverData?.status === 'Rejected' ? 'Correction Requested' : ''}</span> 
          </p>
          <Divider className={styles.mb2} />
          <Stack direction='column' spacing={1}>
            <Typography variant='caption' component='small' color={grey[900]} lineHeight='normal' fontWeight='bold'>
                By:&nbsp;
              <Typography variant='caption' component='small' color={grey[800]} lineHeight='normal'>
                {`${props.popoverData?.last_log?.user?.first_name || ''} ${props.popoverData?.last_log?.user?.last_name || ''}`}
              </Typography>
            </Typography>
            <Typography variant='caption' component='small' color={grey[900]} lineHeight='normal' fontWeight='bold'>
                Reason:&nbsp;
              <Typography variant='caption' component='small' color={grey[800]} lineHeight='normal'>
                {`${props.popoverData?.last_log?.remark || ''}`} 
              </Typography>
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Popper>

    <FlightReportModal showModal={props.modal} closeModal={props.onClose} iframeRef={props.iframeRef}
      handleModalOpen={props.handleModalOpen}
      modalOpen={props.modalOpen}
      handleModalClose={props.handleModalClose}
      flight={props.flightReportData}
      ctype={props.cont_item}
    />

    <ProgressModal 
      handleOpen={props.handleOpen}
      onClose={props.onClose}
      modal={props.modal}
      progress={props.progress}
      invoiceDownload={invoiceDownload}
    />
    
    <EncryptionContainer
      startTimer={props.startTimer}
      stopInterval={props.stopInterval}
      handleOpen={props.handleOpen}
      modal={props.modal}
      onClose={props.onClose}
    />

    <Status
      statusModal={props.sessionExpired}
      onClose={props.onClose}
      statusMessage= {{
        type: 'warning',
        size: 'md',
        title: 'Session Expired',
        mainMessage:'Session Expired',
        firstMessage:'Please authenticate again to restart the session.',
        secondMessage:''
      }}
    />
    
    <Status
      statusModal={props.emailPassword}
      onClose={props.onClose}
      statusMessage= {{
        type: 'warning',
        size: 'md',
        title: 'Email Sent',
        mainMessage:'The requested document has been downloaded.',
        firstMessage:'Please note that the password required to open the document is included in the email sent to your registered email address.',
        secondMessage:''
      }}
    />

    {props.modal === 'flt_load_info' &&
      <FlightLoadInfoModal
        modal={props.modal}
        onClose={props.onModalClose}
        reportFields={props.reportFields}
        handleReportChange={props.handleReportChange}
        customReportOptions={props.customReportOptions}
        handleCustomReportSelect={props.handleCustomReportSelect}
        tonSumOpts={props.tonSumOpts}
        flightSumOpts={props.flightSumOpts}
        flightDetOpts={props.flightDetOpts}
        handleExport={props.handleExport}
      />
    }

    {
      props.transitAWBsModal &&
      <div>
        <Dialog aria-labelledby='form-dialog-title' open={props.transitAWBsModal} onClose={props.hideTransitAWBs} maxWidth={'md'} fullWidth>
          <CustomDialogTitle id='form-dialog-title'>
            Transit AWBs
            <CloseIconBtn onClick={props.hideTransitAWBs} />
          </CustomDialogTitle>
          <CustomDialogContent>
            <Stack direction='row' spacing={1} justifyContent='flex-end' alignItems={'center'} mt={'-12px'} mr={2} mb={1}>
              <Typography component='small' variant='initial' className={`${styles.xsW100} ${styles.pr2}`}>Filter:</Typography>            
              <RadioGroup aria-labelledby='log-status' name='platformType' row className={`${styles.pr2}`}
                value={props.transitAWBType}
                onChange={(e) => props.handleTransitAwbChange(e)}
              >
                <Stack direction='row' spacing={3} className={`${styles.fMiddle}`} flexWrap='wrap' sx={{ marginLeft: '-10px' }}>
                  <CustomRadio control={<Radio size='small' />} value='transit' label='Transit AWB' />
                  <CustomRadio control={<Radio size='small' />} value='exclude_transit' label='Excluded Transit AWB' />
                </Stack>
              </RadioGroup>
            </Stack>
            <StyledCard apiRef={props.apiRef}>
              {props.transitAWBType === 'transit' && 
              <>
                <StyledCardTitle gutterBottom>Transit AWBs</StyledCardTitle>
                <StyledTableContainer className={flightInfoStyles.transitAWBTableWrapper}>
                  <Table aria-label='collapsible table' stickyHeader className={flightInfoStyles.styledTable}>
                    <TableHead >
                      <TableRow>
                        <TableCell className={flightInfoStyles.tableHeadCell}>AWB</TableCell>
                        <TableCell className={flightInfoStyles.tableHeadCell}>Quantity</TableCell>
                        <TableCell className={flightInfoStyles.tableHeadCell}>In Flight</TableCell>
                        <TableCell className={flightInfoStyles.tableHeadCell}>Out Flight</TableCell>
                        <TableCell className={flightInfoStyles.tableHeadCell}>Driver</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody >
                      {regularTransitAwbs.length > 0 ? regularTransitAwbs.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell className={flightInfoStyles.tableCell}>{row.awb_no + ' (' +row.org + '-' + row.dest + ')'}</TableCell>
                          <TableCell className={flightInfoStyles.tableCell}>{row.qtyValue}</TableCell>
                          <TableCell className={flightInfoStyles.tableCell}>{row?.inboundInfo && row?.inboundInfo?.flight ? <>
                            <span>{row?.inboundInfo?.flight?.airline + row?.inboundInfo?.flight?.flight_no + '/' + moment(row?.inboundInfo?.flight?.flight_date).format(DateFormat).toUpperCase()}</span> 
                            <span className={flightInfoStyles.platform}>{row?.inboundInfo?.platform.toLowerCase() === 'flight' ? <Flight fontSize='small' color='primary' /> : <LocalShipping fontSize='small' color='primary' />}</span></> : 
                            <span className={flightInfoStyles.missingFlight}> Flight not found</span>}</TableCell>
                          <TableCell className={flightInfoStyles.tableCell}>{row?.outboundInfo && row?.outboundInfo?.flight ? <>
                            <span>{row?.outboundInfo?.flight?.airline + row?.outboundInfo?.flight?.flight_no + '/' + moment(row?.outboundInfo?.flight?.flight_date).format(DateFormat).toUpperCase()}</span> 
                            <span className={flightInfoStyles.platform}>{row?.outboundInfo?.platform.toLowerCase() === 'flight' ? <Flight fontSize='small' color='primary' /> : <LocalShipping fontSize='small' color='primary' />}</span></> : 
                            <span className={flightInfoStyles.missingFlight}> Flight not found</span>}</TableCell>
                          <TableCell className={flightInfoStyles.tableCell}>{row?.label}</TableCell>
                        </TableRow>
                      )) : (
                        <TableRow>
                          <TableCell colSpan={5} className={flightInfoStyles.tableCell} align='center'>No data</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                    {/* <TableFooter>
                    <TableRow>
                      <TableCell className={`${flightInfoStyles.tableCell} ${flightInfoStyles.tableFooterCell}`}>Total</TableCell>
                      <TableCell className={`${flightInfoStyles.tableCell} ${flightInfoStyles.tableFooterCell}`}>{transitQty}</TableCell>
                      <TableCell className={`${flightInfoStyles.tableCell} ${flightInfoStyles.tableFooterCell}`}></TableCell>
                      <TableCell className={`${flightInfoStyles.tableCell} ${flightInfoStyles.tableFooterCell}`}></TableCell>
                      <TableCell className={`${flightInfoStyles.tableCell} ${flightInfoStyles.tableFooterCell}`}></TableCell>
                    </TableRow>
                  </TableFooter> */}
                  </Table>
                </StyledTableContainer>
              </>
              }
              {
                props.transitAWBType === 'exclude_transit' &&
                    highlightedTransitAwbs.length > 0 && (
                  <>
                    <StyledCardTitle gutterBottom>Excluded Transit AWBs</StyledCardTitle>
                    <StyledTableContainer className={flightInfoStyles.transitAWBTableWrapper}>
                      <Table aria-label='highlighted transit awbs table' stickyHeader className={flightInfoStyles.styledTable}>
                        <TableHead>
                          <TableRow>
                            <TableCell className={flightInfoStyles.tableHeadCell}>AWB</TableCell>
                            <TableCell className={flightInfoStyles.tableHeadCell}>Quantity</TableCell>
                            <TableCell className={flightInfoStyles.tableHeadCell}>In Flight</TableCell>
                            <TableCell className={flightInfoStyles.tableHeadCell}>Out Flight</TableCell>
                            <TableCell className={flightInfoStyles.tableHeadCell}>Driver</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {highlightedTransitAwbs.length > 0 ? highlightedTransitAwbs.map((row, index) => (
                            <TableRow key={`${row.awb_no || 'awb'}-${index}`}>
                              <TableCell className={flightInfoStyles.tableCell}>{row.awb_no + ' (' +row.org + '-' + row.dest + ')'}</TableCell>
                              <TableCell className={flightInfoStyles.tableCell}>{row.qtyValue}</TableCell>
                              <TableCell className={flightInfoStyles.tableCell}>{row?.inboundInfo && row?.inboundInfo?.flight ? <>
                                <span>{row?.inboundInfo?.flight?.airline + row?.inboundInfo?.flight?.flight_no + '/' + moment(row?.inboundInfo?.flight?.flight_date).format(DateFormat).toUpperCase()}</span>
                                <span className={flightInfoStyles.platform}>{row?.inboundInfo?.platform.toLowerCase() === 'flight' ? <Flight fontSize='small' color='primary' /> : <LocalShipping fontSize='small' color='primary' />}</span></> :
                                <span className={flightInfoStyles.missingFlight}> Flight not found</span>}</TableCell>
                              <TableCell className={flightInfoStyles.tableCell}>{row?.outboundInfo && row?.outboundInfo?.flight ? <>
                                <span>{row?.outboundInfo?.flight?.airline + row?.outboundInfo?.flight?.flight_no + '/' + moment(row?.outboundInfo?.flight?.flight_date).format(DateFormat).toUpperCase()}</span>
                                <span className={flightInfoStyles.platform}>{row?.outboundInfo?.platform.toLowerCase() === 'flight' ? <Flight fontSize='small' color='primary' /> : <LocalShipping fontSize='small' color='primary' />}</span></> :
                                <span className={flightInfoStyles.missingFlight}> Flight not found</span>}</TableCell>
                              <TableCell className={flightInfoStyles.tableCell}>{row?.label}</TableCell>
                            </TableRow>
                          )) : 
                            <TableRow>
                              <TableCell colSpan={5} className={flightInfoStyles.tableCell} align='center'>No data</TableCell>
                            </TableRow>}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TableCell className={`${flightInfoStyles.tableCell} ${flightInfoStyles.tableFooterCell}`}>Total</TableCell>
                            <TableCell className={`${flightInfoStyles.tableCell} ${flightInfoStyles.tableFooterCell}`}>{transitQty}</TableCell>
                            <TableCell className={`${flightInfoStyles.tableCell} ${flightInfoStyles.tableFooterCell}`}></TableCell>
                            <TableCell className={`${flightInfoStyles.tableCell} ${flightInfoStyles.tableFooterCell}`}></TableCell>
                            <TableCell className={`${flightInfoStyles.tableCell} ${flightInfoStyles.tableFooterCell}`}></TableCell>
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </StyledTableContainer>
                  </>
                )
              }

              <Box className={flightInfoStyles.equalizedTotalWrapper}>
                <Box className={flightInfoStyles.equalizedCalcLeft}>
                  <Typography component='p' className={flightInfoStyles.equalizedCalcTitle}>
                    Equalization Calculation
                  </Typography>

                  <Box className={flightInfoStyles.equalizedRow}>
                    <Typography component='span' className={flightInfoStyles.equalizedRowLabel}>
                      Unequalized Quantity
                    </Typography>
                    <Typography component='span' className={flightInfoStyles.equalizedRowValue}>
                      {props.contractQty}
                    </Typography>
                  </Box>

                  <Box className={flightInfoStyles.equalizedRow}>
                    <Typography component='span' className={`${flightInfoStyles.equalizedRowLabel} ${flightInfoStyles.equalizedMinus}`}>
                      Transit AWBs Quantity
                    </Typography>
                    <Typography component='span' className={`${flightInfoStyles.equalizedRowValue} ${flightInfoStyles.equalizedMinus}`}>
                      - {transitQty}
                    </Typography>
                  </Box>

                  <Box className={flightInfoStyles.equalizedFormulaStrip}>
                    <Typography component='span' className={flightInfoStyles.equalizedRowLabel}>
                      Equalized Quantity
                    </Typography>
                    <Typography component='span' className={flightInfoStyles.equalizedRowValue}>
                      {props.contractEqualizedQty}
                    </Typography>
                  </Box>
                </Box>

                <Box className={flightInfoStyles.equalizedCalcRight}>
                  <Typography component='p' className={flightInfoStyles.equalizedFinalLabel}>
                    Final Equalized Quantity
                  </Typography>
                  <Typography component='p' className={flightInfoStyles.equalizedFinalValue}>
                    {props.contractEqualizedQty}
                    <Typography component='span' className={flightInfoStyles.equalizedUnit}>
                      KGS
                    </Typography>
                  </Typography>
                </Box>
              </Box>
            </StyledCard>
          </CustomDialogContent>
          
        </Dialog>
      </div>
    }
    
  </>;

};

export default FlightLoadInfo;
